module.exports = __webpack_public_path__ + "img/icons BFr_31.dca9353a.png";